@if (data) {
  <markant-table
    class="table"
    [variant]="data.tableVariant || 'light'"
    [sortColumnId]="sortColumnId$ | async"
    [sortDirection]="data.sortStartDirection"
    [loading]="loading"
    [stickyHeader]="stickyHeader"
    (sortChange)="onSortChange($any($event).detail)"
  >
    <markant-progress-bar
      slot="markant-table-loading-indicator"
      [indeterminate]="true"
      debounce="200"
    ></markant-progress-bar>
    <tr slot="header-row">
      @if (data.showCheckBoxes) {
        <td class="selection-header" id="checkbox-header-table">
          <markant-checkbox
            [checked]="allRowsOnPageSelected()"
            (checkedChange)="toggleAllSelections($any($event).detail)"
          ></markant-checkbox>
        </td>
      }
      @if (data.showRadioButtons) {
        <td class="selection-header" id="radiobutton-header-table"></td>
      }
      @for (
        headerCell of data.headerCells;
        track headerCell.headerCellColumnId
      ) {
        <th
          scope="col"
          [title]="
            headerCell?.headerCellTitle ??
            (headerCell.headerCellTranslationKey | transloco)
          "
          class="table-header-cell"
        >
          <markant-table-header-cell
            [label]="
              headerCell?.headerCellTitle ??
              (headerCell.headerCellTranslationKey | transloco)
            "
            [columnId]="headerCell.headerCellColumnId"
            [sortStart]="headerCell.sortDirection"
            [sortDirection]="headerCell.sortDirection"
            [notSortable]="!headerCell.isSortable"
            class="header-cell"
          ></markant-table-header-cell>
        </th>
      }
    </tr>

    @if (data.tableRows && data.tableRows.length) {
      @for (
        tableRow of data.tableRows;
        let i = $index;
        track tableRow.entryId
      ) {
        <tr
          class="table-row"
          [class.row-default]="data.disabledRowLink"
          (click)="goTo(tableRow)"
          (keydown.enter)="goTo(tableRow)"
        >
          @if (data.showCheckBoxes) {
            <td class="selection-cell">
              @if (tableRow.showCheckBox) {
                <markant-checkbox
                  [checked]="selectedIds.has(tableRow.entryId)"
                  (click)="onClickCheckbox($event, tableRow.entryId)"
                  (checkedChange)="
                    toggleSelect(tableRow.entryId, tableRow.version)
                  "
                ></markant-checkbox>
              }
            </td>
          }
          @if (data.showRadioButtons) {
            <td class="selection-cell">
              <markant-radio
                [checked]="selectedId === tableRow.entryId"
                (click)="onClickRadioButton($event, tableRow.entryId)"
              ></markant-radio>
            </td>
          }

          @for (tableCell of tableRow.tableCells; track $index) {
            <td
              [ngClass]="{
                'table-cell': tableCell.contentType !== 'SELECT',
                'selection-cell': tableCell.contentType === 'SELECT',
                'action-cell': tableCell.contentType === 'ACTION',
                truncated: tableCell.truncate === true,
              }"
              [title]="
                ((tableCell.contentType === 'ACTION' ||
                  tableCell.truncate === true) &&
                  tableCell.label) ||
                ''
              "
            >
              @if (tableCell.contentType === 'SELECT') {
                <markant-checkbox
                  [disabled]="
                    (tableCell.isEditable
                      ? !tableCell.isEditable(tableRow.object)
                      : false) ||
                    (tableCell.isEditable$
                      ? (tableCell.isEditable$ | async) === false
                      : false)
                  "
                  [checked]="
                    selectedIds.has(
                      (tableCell.selectionPrefix | defaultValue) +
                        tableRow.entryId
                    )
                  "
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation()"
                  (checkedChange)="
                    toggleSelect(
                      tableRow.entryId,
                      tableRow.version,
                      tableCell.selectionPrefix
                    )
                  "
                ></markant-checkbox>
              }

              @if (
                tableCell.contentType === 'ICONS' &&
                tableCell.iconElements &&
                tableCell.iconElements.length > 0 &&
                tableCell.content
              ) {
                <markant-icon-button
                  *ngFor="let element of tableCell.iconElements"
                  class="readonly-btn"
                  [icon]="element.icon"
                  [colorScheme]="element.colorScheme"
                  [style.font-size]="element.size"
                >
                </markant-icon-button>
              }

              @if (
                tableCell.contentType === 'ACTION' &&
                tableCell.actionElements &&
                tableCell.actionElements.length &&
                tableCell.content
              ) {
                @for (element of tableCell.actionElements; track $index) {
                  <markant-icon-button
                    [class.default-icon]="element.dynamicIcons"
                    [icon]="
                      element.dynamicIcons ? tableCell.content : element.icon
                    "
                    [colorScheme]="element.colorScheme"
                    [style.fontsize]="element.size"
                    [disabled]="tableRow.disabledRow"
                    [id]="'action-button-' + $index"
                    (click)="
                      !tableRow.disabledRow &&
                        functionCaller(
                          element.function,
                          tableRow.object,
                          tableCell.content
                        )
                    "
                    (keydown.enter)="
                      !tableRow.disabledRow &&
                        functionCaller(
                          element.function,
                          tableRow.object,
                          tableCell.content
                        )
                    "
                  >
                  </markant-icon-button>
                }
              }

              @if (
                tableCell.contentType === 'CHIP_PREDEFINED' &&
                tableCell.chips &&
                tableCell.chips.length
              ) {
                @for (chip of tableCell.chips; track $index) {
                  <markant-chip
                    [colorScheme]="chip.colorScheme"
                    [label]="chip.labelTranslationKey"
                    [title]="chip.labelTranslationKey"
                    [readonly]="chip.readonly"
                  >
                    @if (chip.icon) {
                      <markant-icon
                        slot="icon-leading"
                        [icon]="chip.icon"
                      ></markant-icon>
                    }
                  </markant-chip>
                }
              }

              @if (
                tableCell.contentType === 'CHIP' &&
                tableCell.chips &&
                tableCell.chips.length
              ) {
                <div
                  [ngClass]="{ 'chip-cell': tableCell.contentType === 'CHIP' }"
                >
                  @for (chip of tableCell.chips; track $index) {
                    <markant-chip
                      [colorScheme]="chip.colorScheme"
                      [label]="chip.labelTranslationKey | transloco"
                      [title]="chip.labelTranslationKey | transloco"
                      [readonly]="chip.readonly"
                    >
                      @if (chip.icon) {
                        <markant-icon
                          slot="icon-leading"
                          [icon]="chip.icon"
                        ></markant-icon>
                      }
                    </markant-chip>
                  }
                </div>
              }

              @if (
                tableCell.contentType === 'CHIP_AND_STRING' &&
                tableCell.chips &&
                tableCell.chips.length
              ) {
                @for (chip of tableCell.chips; track $index) {
                  <markant-chip
                    [colorScheme]="chip.colorScheme"
                    [label]="chip.labelTranslationKey | transloco"
                    [title]="chip.labelTranslationKey | transloco"
                    [readonly]="chip.readonly"
                  >
                    @if (chip.icon) {
                      <markant-icon
                        slot="icon-leading"
                        [icon]="chip.icon"
                      ></markant-icon>
                    }
                  </markant-chip>
                }
              }

              @if (
                tableCell.contentType !== 'CHIP_PREDEFINED' &&
                tableCell.contentType !== 'ICONS' &&
                tableCell.contentType !== 'CHIP' &&
                tableCell.contentType !== 'ACTION' &&
                tableCell.content &&
                tableCell.content.length
              ) {
                {{ tableCell.content }}<br />
              }
            </td>
          }
        </tr>
      }
    } @else {
      <tr>
        <td
          class="no-results"
          [colSpan]="
            data.showCheckBoxes
              ? data.headerCells.length + 1
              : data.headerCells.length
          "
        >
          {{ 'common.noResults' | transloco }}
        </td>
      </tr>
    }

    <div slot="table-footer" class="table-paginator" *ngIf="showPagination">
      <markant-platform-pagination-footer
        [totalCount]="totalCount"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        (indexChanged)="onIndexChange($any($event).detail)"
        (pageSizeChanged)="onPageSizeChange($any($event).detail)"
      >
      </markant-platform-pagination-footer>
    </div>
  </markant-table>
} @else {
  <markant-table class="table" [loading]="loading">
    <markant-progress-bar
      slot="loading-indicator"
      [indeterminate]="true"
      debounce="200"
    ></markant-progress-bar>
    <tr slot="header-row">
      @for (headerCell of visibleCells(); track headerCell.headerCellColumnId) {
        <th
          scope="col"
          [title]="
            headerCell?.headerCellTitle ??
            (headerCell.headerCellTranslationKey | transloco)
          "
          class="table-header-cell"
        >
          <markant-table-header-cell
            class="header-cell"
            [label]="
              headerCell?.headerCellTitle ??
              (headerCell.headerCellTranslationKey | transloco)
            "
            [columnId]="headerCell.headerCellColumnId"
            [sortStart]="headerCell.sortDirection"
            [sortDirection]="headerCell.sortDirection"
            [notSortable]="!headerCell.isSortable"
          ></markant-table-header-cell>
        </th>
      }
    </tr>
  </markant-table>
}
